export default {
  entities: {
    applicationCondition: {
      noActiveConditionAlert: 'Sizda faol shartlar mavjud emas',
      card: {
        months: 'Oy',
        sumPerMonth: "so'm / oy",
        applicationAmount: 'Ariza narxi',
        downPaymentAmount: "Oldindan to'lov",
        commission: 'Ustama',
        creditAmount: "Muttadli to'lov narxi",
      },
    },
  },
};
